import React from "react";
import {
    ConnectionProvider,
    IntegrationConnection,
} from "@common/types/integrationConnection";
import {
    INTEGRATION_CONNECTIONS_SETTINGS,
    IntegrationConnectionCapability,
} from "@common/helpers/integrationConnection";
import { useTypedFlags } from "@hooks/useTypedFlags";
import { SingleAccountConnections } from "./SingleAccountConnections";
import { MultiAccountConnections } from "./MultiAccountConnections";
import { AccountingIntegrationConnections } from "./AccountingIntegrationConnections";

interface Props {
    integrationConnections: IntegrationConnection[];
    provider: ConnectionProvider;
}

export const ProviderIntegrationConnections: React.FC<Props> = ({
    integrationConnections,
    provider,
}) => {
    const settings = INTEGRATION_CONNECTIONS_SETTINGS[provider];
    const { quickbooksMigration } = useTypedFlags();

    if (
        settings.capabilities.includes(
            IntegrationConnectionCapability.TRANSACTIONS,
        )
    ) {
        if (settings.transactions?.multipleAccountsPerConnection) {
            return (
                <MultiAccountConnections
                    integrationConnections={integrationConnections}
                    provider={provider}
                />
            );
        }

        return (
            <SingleAccountConnections
                integrationConnections={integrationConnections}
                provider={provider}
            />
        );
    }

    if (
        settings.capabilities.includes(
            IntegrationConnectionCapability.ACCOUNTING,
        ) &&
        quickbooksMigration
    ) {
        return (
            <AccountingIntegrationConnections
                integrationConnections={integrationConnections}
                provider={provider}
            />
        );
    }

    return null;
};
